import React from 'react';
import { connect } from 'react-redux';
import { NavLink, Link } from "react-router-dom";
import * as AuthAction from '../actions/authAction';
import { isEmpty } from 'lodash';
import NotificationList from './NotificationList';

class Header extends React.Component {
    constructor(props) {
        super(props);
        this.onLogout = this.onLogout.bind(this);
    }

    fetchNotifications = () => {
        this.props.getNotifications();
    }

    onLogout() {
        this.props.logout();
    }

    componentDidUpdate(prevProps) {
        if (isEmpty(prevProps.user) && !isEmpty(this.props.user)) {
            this.props.getNotificationCount();
            this.countInterval = setInterval(() => {
                this.props.getNotificationCount();
            }, 60000);
        }
        if (!isEmpty(prevProps.user) && isEmpty(this.props.user)) {
            clearInterval(this.countInterval);
        }
    }

    showNotifications = () => {
        const { notifications: { successResponse } } = this.props;
        return successResponse.data.map((item) => (
            <NotificationList item={item} />
        ))
    }
    render() {
        const { user } = this.props;
        const { notifications: { successResponse, notification_count } } = this.props;
        return (
            <header>
                <div className="container flex">
                    <NavLink to="/dashboard"><img src="/images/daisy-logo.svg" alt="daisy logo" /></NavLink>
                    <nav>
                        <ul className="flex menu">
                            <li className=""><NavLink to="/dashboard">Home</NavLink></li>
                            <li className=""><NavLink to="/contact-us">Contact us</NavLink></li>
                            <li className=""><NavLink to="/faqs">Faq</NavLink></li>
                            {!isEmpty(user) && <li className="notification_menu" onClick={this.fetchNotifications}><a href="#"><i className="notification_icon">{notification_count > 0 && <span className="badge badge-primary">{notification_count}</span>}
                            </i></a>
                                {successResponse && !isEmpty(successResponse.data) && <div className="notification_details">
                                    <ul>
                                        {this.showNotifications()}
                                    </ul>
                                    {/* <a className="see-all-notification" href="#">See All Notification</a> */}
                                </div>}
                            </li>}
                            {!isEmpty(user) && <li className="setting"><a href="#"><i className="settings_icon"></i></a>
                                <ul className="sub-menu">
                                    <li className="menu-title">Settings</li>
                                    <li><NavLink to="/profile" className="flex"><i className="avatar-icon"></i><p><span>{user.full_name}</span><small>{user.contact_number}</small></p></NavLink></li>
                                    <li><NavLink to="/appointments" className="flex"><i className="appointment-icon"></i><p><span>Appointment Management</span></p></NavLink></li>
                                    <li><NavLink to="/change-password"
                                        className="flex"><i className="password-icon"></i><p><span>Change Password</span></p></NavLink></li>
                                    <li><Link onClick={this.onLogout} className="flex"><i className="logout-icon"></i><p><span>Logout</span></p></Link></li>
                                </ul>
                            </li>}
                        </ul>
                    </nav>
                </div>
            </header>
        );
    }
}

const mapStateToProps = (state) => ({
    user: state.session.user,
    notifications: state.notifications,

});

const mapActionsToProps = ({
    logout: AuthAction.logout,
    getNotifications: AuthAction.getPatientUserNotification,
    getNotificationCount: AuthAction.getNotificationCount,
})

export default connect(mapStateToProps, mapActionsToProps)(Header);
